import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './style.css'; // ✅ Importar estilos globales

createApp(App).use(router).mount('#app');